import { useScrollReveal } from '../../../useScrollReveal';
import GrainOverlay from '../../../GrainOverlay';
import './PullQuote.css';

const PullQuote = ({ text, body, variant = 'warm', revealDirection }) => {
    const direction = revealDirection || (variant === 'warm' ? 'slideRight' : 'slideLeft');
    const { ref, style } = useScrollReveal(direction);

    return (
        <blockquote
            className={`PullQuote PullQuote--${variant}`}
            ref={ref}
            style={style}
        >
            <GrainOverlay intensity={0.06} />
            <span className="PullQuote-quote" aria-hidden="true">&ldquo;</span>
            <p className="PullQuote-text">{text}</p>
            {body && (
                <div
                    className="PullQuote-body"
                    dangerouslySetInnerHTML={{ __html: body }}
                />
            )}
        </blockquote>
    );
};

export default PullQuote;
